import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { formatExpectedResponse } from '../../../../../services/mini/formatExpectedResponse';
import { getHtmlForExpectedResponse } from '../../../../../services/mini/getHtmlForExpectedResponse';
import _ from 'lodash';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import cancelEvent from '../../../../../services/mini/cancelEvent';
import getConversationId from '../../../../../services/mini/getConversationId';
import ToasterService from '../../../../../services/ToasterService';
import TextareaAutosize from 'react-textarea-autosize';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import PopupWrapper from '../../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../../components/Popup/PopupHeader';
import PopupBody from '../../../../components/Popup/PopupBody';

class ExpectedResponsesTestModeBubble extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            expectedResponse: '',
            condition: props.node.visualProperties?.condition || 'or',
            editMode: props.node.visualProperties?.expectedResponses?.length === 0,
            showFullMode: props.showExpectedResponses
        };

        this.inputEl = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutsideCb, true);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.showExpectedResponses !== this.props.showExpectedResponses) {
            if (this.state.showFullMode !== this.props.showExpectedResponses) {
                this.setState({ showFullMode: this.props.showExpectedResponses });
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutsideCb, true);
    }

    handleClickOutsideCb = (e) => {
        const domNode = ReactDOM.findDOMNode(this);
        const { node } = this.props;
        const { expectedResponse } = this.state;

        if (e.target.classList.contains('toast') ||
            e.target.closest('.toast') !== null) {
            return;
        }

        if (e.target.classList.contains('add-expected-response')) {
            return;
        }

        if ((!domNode || !domNode.contains(e.target))) {
            if (expectedResponse.trim().length > 0) {
                this.addExpectedResponse();
            } else {
                this.closeEditMode();
            }
        }
    }

    onChange = (e) => {
        this.setState({ expectedResponse: e.target.value });
    }

    onKeyDown = (e) => {
        const keyCode = e.keyCode || e.which;

        if (keyCode === 13) {
            cancelEvent(e);
            this.addExpectedResponse();
        }
        if (keyCode === 27) {
            this.closeEditMode();
        }
    }

    closeEditMode = () => {
        const { node } = this.props;
        if (node.visualProperties?.expectedResponses?.length > 0) {
            this.setState({ editMode: false });
        } else {
            this.deleteAllExpectedResponses();
        }
    }

    openEditMode = () => {
        const { editMode } = this.state;
        const { node } = this.props;
        if (!editMode) {
            this.setState({
                editMode: true,
                expectedResponse: node.visualProperties?.expectedResponses || ''
            });
        }
    }

    openFullViewMode = () => {
        this.setState({
            showFullMode: true
        });
    }

    addExpectedResponse = () => {
        const { expectedResponse, condition } = this.state;
        const { node, conversationId, addExpectedResponse, dialogTree } = this.props;
        const trimmedExpectedResponse = expectedResponse.trim();

        if (trimmedExpectedResponse === '') {
            this.inputEl.current.focus();
            return;
        }

        if (trimmedExpectedResponse.length > 0 || expectedResponse === '') {
            addExpectedResponse({
                conversationId,
                node,
                dialogTree,
                response: expectedResponse,
                condition
            }).then(() => {
                this.setState({
                    expectedResponse: '',
                    editMode: false
                });
            });
        }
    }

    editExpectedResponse = (response, responseIndex) => {
        const { node, conversationId, editExpectedResponse, dialogTree } = this.props;
        editExpectedResponse({
            conversationId,
            node,
            dialogTree,
            response,
            responseIndex
        });
    }

    deleteExpectedResponse = (response) => {
        const { node, conversationId, deleteExpectedResponse, dialogTree } = this.props;
        deleteExpectedResponse({
            conversationId,
            node,
            dialogTree,
            response
        });
    }

    showHelp = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <PopupWrapper>
                        <PopupHeader
                            title="Expected Responses Help"
                            titleIcon="icon-alan-support"
                            onCancel={onClose} />
                        <PopupBody>
                            <div style={{ minHeight: '170px' }}>
                                Specify the responses your voice assistant expects:
                                <div>— Use AND, OR or NOT for compound responses</div>
                                <div>— Enclose phrases with apostrophe in double quotes</div>
                                <br />
                                For example:
                                <div>— <b>hello OR (hi AND "what's up")</b></div>
                                <div>— <b>NOT hello</b></div>
                            </div>
                        </PopupBody>
                    </PopupWrapper>
                );
            }
        });
    }

    copyAllExpectedResponses = () => {
        const { node, copyAllExpectedResponses } = this.props;
        copyAllExpectedResponses({ node });
    }

    deleteAllExpectedResponses = () => {
        const { node, conversationId, deleteAllExpectedResponses, dialogTree } = this.props;
        deleteAllExpectedResponses({
            conversationId,
            node,
            dialogTree
        });
    }

    render() {
        const { expectedResponse, editMode, showFullMode } = this.state;
        const { node, showExpectedResponses } = this.props;
        const failed = node.isPassed() === false;
        const passed = node.isPassed() === true;
        const isShortMode = !showFullMode && !showExpectedResponses && !editMode;

        let expectedResponses = null;

        if (node.visualProperties?.expectedResponses) {
            expectedResponses = formatExpectedResponse(node.visualProperties?.expectedResponses);
        }

        return (
            <div className={`expected-responses ${failed && 'failed'} ${passed && 'passed'} ${(passed || failed) && 'with-special-state'} ${(isShortMode) ? 'short-mode' : 'full-mode'}`}>
                <div className="expected-responses__header">
                    {failed && <i className="icon icon-alan-test-attention test-failed" />}
                    <div className="expected-responses__header-title">
                        Expected responses: {failed && 'not found'}</div>
                    <i
                        className="icon icon-alan-help-sign help-icon" title="Help"
                        onClick={this.showHelp} />
                    <i
                        title="Copy expected response"
                        className="icon icon-alan-test-copy copy-expected-response-buble-icon"
                        onClick={this.copyAllExpectedResponses} />
                    <i
                        title="Delete expected response"
                        className="icon icon-alan-test-delete-response remove-expected-response-buble-icon"
                        onClick={this.deleteAllExpectedResponses} />
                </div>
                <ul className="expected-responses__body"
                    onClick={isShortMode ? this.openFullViewMode : this.openEditMode}>
                    {editMode ?
                        <TextareaAutosize
                            minRows={2}
                            maxRows={15}
                            autoFocus={true}
                            ref={this.inputEl}
                            value={expectedResponse}
                            onKeyDown={this.onKeyDown}
                            onChange={this.onChange}
                        /> :
                        <React.Fragment>
                            {getHtmlForExpectedResponse(expectedResponses)}
                        </React.Fragment>}
                </ul>
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        dialogTree: testMode.dialogTree,
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addExpectedResponse: (param) => asyncDispatch(actions.addExpectedResponse, dispatch, param),
        editExpectedResponse: (param) => asyncDispatch(actions.editExpectedResponse, dispatch, param),
        copyAllExpectedResponses: (param) => asyncDispatch(actions.copyAllExpectedResponses, dispatch, param),
        deleteExpectedResponse: (param) => asyncDispatch(actions.deleteExpectedResponse, dispatch, param),
        deleteAllExpectedResponses: (param) => asyncDispatch(actions.deleteAllExpectedResponses, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ExpectedResponsesTestModeBubble);
